<app-organization-sidebar-layout>
  <app-page-header>
    <app-page-title>
      {{ 'cockpit.energyInterfaces.page.title' | transloco }}
    </app-page-title>
    <div slot="end" class="flex flex-row max-[450px]:flex-col gap-2">
      <ui-button
        expand="full"
        data-track="cockpit-energy-interface-create-button"
        (click)="onClickAddEnergyInterface(null)"
        [disabled]="locations().length <= 0"
        [uiTooltip]="
          locations().length <= 0
            ? ('cockpit.energyInterfaces.page.addEnergyInterfaceButtonDisabledTooltip' | transloco)
            : null
        "
      >
        <ng-icon slot="start" name="heroServer" size="20" class="!block" />
        {{ 'cockpit.energyInterfaces.page.addEnergyInterfaceButton' | transloco }}
      </ui-button>
    </div>
  </app-page-header>

  <form
    slot="sticky-header"
    class="flex flex-col md:grid grid-cols-3 gap-3"
    (submit.prevent)="onChangeFilter()"
  >
    <div class="flex gap-3">
      <ui-input-simple
        data-track="cockpit-energy-interface-search"
        [placeholder]="'cockpit.energyInterfaces.page.searchPlaceholder' | transloco"
        [formField]="filterForm.query"
        (fieldValueChange)="onChangeFilter()"
        class="flex-1"
      >
        <div slot="start" class="text-on-surface-disabled">
          <ng-icon name="heroMagnifyingGlass" size="16" class="!block" />
        </div>
      </ui-input-simple>
      <ui-button
        [iconOnly]="true"
        mode="outlined"
        class="md:hidden flex-none"
        [ariaLabel]="'cockpit.energyInterfaces.page.mobileFilterOpenButton' | transloco"
        (click)="mobileFilterDialog.showModal()"
      >
        <ng-icon name="heroFunnel" size="20" class="!block" />
      </ui-button>
    </div>
    <ui-select
      [formField]="filterForm.utilityType"
      (selectChange)="onChangeFilter()"
      class="hidden md:block"
    >
      <option value="" [selected]="!filter().utilityType">
        {{ 'cockpit.energyInterfaces.page.filterAllTypesLabel' | transloco }}
      </option>
      <option value="GAS" [selected]="filter().utilityType === 'GAS'">
        {{ 'cockpit.energyInterfaces.page.filterGasLabel' | transloco }}
      </option>
      <option value="ELECTRICITY" [selected]="filter().utilityType === 'ELECTRICITY'">
        {{ 'cockpit.energyInterfaces.page.filterElectricityLabel' | transloco }}
      </option>
    </ui-select>
    <ui-select
      [formField]="filterForm.locationId"
      (selectChange)="onChangeFilter()"
      class="hidden md:block"
    >
      <option value="" [selected]="!filter().locationId">
        {{ 'cockpit.energyInterfaces.page.filterAllLocationsLabel' | transloco }}
      </option>
      @for (location of locations(); track location.id) {
        <option [value]="location.id" [selected]="filter().locationId === location.id">
          {{ location.data | formatLocationName }}
        </option>
      }
    </ui-select>

    <ui-simple-dialog #mobileFilterDialog>
      <ui-simple-dialog-layout class="w-full" (clickCancel)="mobileFilterDialog.close()">
        <ng-container slot="title">
          {{ 'cockpit.energyInterfaces.page.mobileFilterDialogTitle' | transloco }}
        </ng-container>
        <div class="flex flex-col gap-6">
          <ui-select [formField]="filterForm.utilityType" (selectChange)="onChangeFilter()">
            <option value="" [selected]="!filter().utilityType">
              {{ 'cockpit.energyInterfaces.page.filterAllTypesLabel' | transloco }}
            </option>
            <option value="GAS" [selected]="filter().utilityType === 'GAS'">
              {{ 'cockpit.energyInterfaces.page.filterGasLabel' | transloco }}
            </option>
            <option value="ELECTRICITY" [selected]="filter().utilityType === 'ELECTRICITY'">
              {{ 'cockpit.energyInterfaces.page.filterElectricityLabel' | transloco }}
            </option>
          </ui-select>
          <ui-select [formField]="filterForm.locationId" (selectChange)="onChangeFilter()">
            <option value="" [selected]="!filter().locationId">
              {{ 'cockpit.energyInterfaces.page.filterAllLocationsLabel' | transloco }}
            </option>
            @for (location of locations(); track location.id) {
              <option [value]="location.id" [selected]="filter().locationId === location.id">
                {{ location.data | formatLocationName }}
              </option>
            }
          </ui-select>
        </div>
      </ui-simple-dialog-layout>
    </ui-simple-dialog>
  </form>

  <div class="flex flex-col gap-5">
    @if (loading()) {
      <ul class="flex flex-col gap-6">
        <li><app-energy-interface-location-skeleton /></li>
        <li><app-energy-interface-location-skeleton /></li>
      </ul>
    } @else if (loadError()) {
      <app-error-page
        [error]="loadError()"
        (clickBack)="router.navigate(['/organizations'])"
        class="block"
        style="height: calc(100vh - 30rem)"
      />
    } @else if (locations().length === 0) {
      <app-energy-interfaces-empty-box [organizationId]="organizationId()" />
    } @else {
      <ul class="flex flex-col gap-6">
        @for (location of filteredLocations(); track location.id) {
          <li>
            <app-energy-interface-location
              [location]="location"
              (clickCreate)="onClickAddEnergyInterface($event)"
              [organizationId]="organizationId()"
            />
          </li>
        } @empty {
          <app-energy-interface-list-no-results (clickReset)="onClickResetFilter()" />
        }
        @if (locationLessEnergyInterfaces().length > 0) {
          <li>
            <app-energy-interface-list-section>
              <div slot="title" class="flex items-center gap-1 overflow-hidden">
                <ng-icon
                  name="heroMapPin"
                  size="20"
                  slot="icon"
                  class="!block mr-0.5 flex-shrink-0"
                />
                <span class="overflow-hidden text-ellipsis whitespace-nowrap">
                  {{ 'cockpit.energyInterfaces.list.withoutLocation' | transloco }}
                </span>
              </div>
              <app-energy-interface-list>
                @for (energyInterface of locationLessEnergyInterfaces(); track energyInterface.id) {
                  <app-energy-interface-list-entry
                    [energyInterface]="energyInterface"
                    [organizationId]="organizationId()"
                  />
                }
              </app-energy-interface-list>
            </app-energy-interface-list-section>
          </li>
        }
      </ul>
    }
  </div>
</app-organization-sidebar-layout>

<app-tutorial-energy-interfaces-popover />

<ui-simple-dialog #createEnergyInterfaceDialog>
  <app-energy-interface-create-dialog
    [locationId]="selectedLocation()"
    class="w-full"
    (clickCancel)="createEnergyInterfaceDialog.close()"
    (createSuccess)="onCreateSuccess($event)"
  />
</ui-simple-dialog>
